import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15

export default {
    services: {
        getRates: (limit = 15, page = 1, query = "", token) => {
            return axios(token).get(`/rates?limit=${limit}&page=${page}${query ? `&${query}` : ""}`)
        },
        createRate: (body, token) => {
            return axios(token).post(`/rates`, body);
        },
        getRateById: (rateId, token) => {
            return axios(token).get(`/rates/${rateId}`);
        },
        updateRateById: (rateId, body, token) => {
            return axios(token).put(`/rates/${rateId}`, body);
        },
        deleteRateById: (rateId, token) => {
            return axios(token).delete(`/rates/${rateId}`);
        },
        getRatesByBranchId: (branchId, limit = 15, page = 1, query = "", token) => {
            return axios(token).get(`/branches/${branchId}/rates?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
        },
        getTransferPricingQuotation: (payload, token = "") => {
            return axios(token).post(`/transfer-pricing/quotation`, payload);
        },
        deleteManyRatesById: (rates, token) => {
            return axios(token).post(`/bulk-delete-rates`, rates)
        },
        /***
        * 
        * History service
        * 
        * ***/
        getHistoriesByRateId: (rateId, limit, page, token) => {
            return axios(token).get(`/modules/rates/${rateId}/histories?limit=${limit}&page=${page}`)
        },
        updateHistoryById: (historyId, history, token) => {
            return axios(token).put(`/histories/${historyId}`, history)
        },
        updateAnyAttributeById: (rateId, body, token = "") => {
            return axios(token).patch(`/rates/${rateId}`, body);
        }
    }
}